import { useMemo } from 'react';
import { Row, Col, ClientForm, ClientFormProps } from '@gv/triage-components';

import { IClientDetails } from 'types';
import { clientAddress, getClientEmails } from 'utils/helpers';
import { useDetailsQuery as useClientQuery } from 'store/api/clients';

const initialProps = {
  name: '',
  address: '',
  emails: [] as string[],
};

export const ClientInfo = ({
  clientId,
  hospitalId,
  client_details,
}: {
  clientId?: string;
  hospitalId?: string;
  client_details?: IClientDetails;
}) => {
  const { data: client } = useClientQuery(
    { hospitalId, id: clientId!, allowDeleted: true },
    {
      skip: !clientId,
    }
  );

  const props = useMemo<Partial<ClientFormProps>>(() => {
    if (client_details) {
      return {
        name: client_details.name,
        phones: client_details.phones,
        emails: client_details.emails,
        address: client_details.address,
        mainPhone: client_details.mainPhone,
        homePhones: client_details.homePhones,
      };
    }
    if (client) {
      return {
        name: client.name,
        phones: client.phones,
        mainPhone: client.phone,
        homePhones: client.home_phones,
        emails: getClientEmails(client),
        address: clientAddress(client) ?? undefined,
      };
    }

    return initialProps;
  }, [client, client_details]);

  return (
    <Row>
      <Col>
        <ClientForm
          isNameConfirmed
          isPhoneConfirmed
          withPlaceholders={false}
          {...props}
        />
      </Col>
    </Row>
  );
};
